(function () {
  function r(e, n, t) {
    function o(i, f) {
      if (!n[i]) {
        if (!e[i]) {
          var c = "function" == typeof require && require;
          if (!f && c) return c(i, !0);
          if (u) return u(i, !0);
          var a = new Error("Cannot find module '" + i + "'");
          throw ((a.code = "MODULE_NOT_FOUND"), a);
        }
        var p = (n[i] = { exports: {} });
        e[i][0].call(
          p.exports,
          function (r) {
            var n = e[i][1][r];
            return o(n || r);
          },
          p,
          p.exports,
          r,
          e,
          n,
          t
        );
      }
      return n[i].exports;
    }
    for (
      var u = "function" == typeof require && require, i = 0;
      i < t.length;
      i++
    )
      o(t[i]);
    return o;
  }
  return r;
})()(
  {
    1: [
      function (require, module, exports) {
        "use strict";
        var __assign =
          (this && this.__assign) ||
          function () {
            __assign =
              Object.assign ||
              function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                  s = arguments[i];
                  for (var p in s)
                    if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
              };
            return __assign.apply(this, arguments);
          };
        var __awaiter =
          (this && this.__awaiter) ||
          function (thisArg, _arguments, P, generator) {
            function adopt(value) {
              return value instanceof P
                ? value
                : new P(function (resolve) {
                    resolve(value);
                  });
            }
            return new (P || (P = Promise))(function (resolve, reject) {
              function fulfilled(value) {
                try {
                  step(generator.next(value));
                } catch (e) {
                  reject(e);
                }
              }
              function rejected(value) {
                try {
                  step(generator["throw"](value));
                } catch (e) {
                  reject(e);
                }
              }
              function step(result) {
                result.done
                  ? resolve(result.value)
                  : adopt(result.value).then(fulfilled, rejected);
              }
              step(
                (generator = generator.apply(thisArg, _arguments || [])).next()
              );
            });
          };
        var __generator =
          (this && this.__generator) ||
          function (thisArg, body) {
            var _ = {
                label: 0,
                sent: function () {
                  if (t[0] & 1) throw t[1];
                  return t[1];
                },
                trys: [],
                ops: [],
              },
              f,
              y,
              t,
              g;
            return (
              (g = { next: verb(0), throw: verb(1), return: verb(2) }),
              typeof Symbol === "function" &&
                (g[Symbol.iterator] = function () {
                  return this;
                }),
              g
            );
            function verb(n) {
              return function (v) {
                return step([n, v]);
              };
            }
            function step(op) {
              if (f) throw new TypeError("Generator is already executing.");
              while (_)
                try {
                  if (
                    ((f = 1),
                    y &&
                      (t =
                        op[0] & 2
                          ? y["return"]
                          : op[0]
                          ? y["throw"] || ((t = y["return"]) && t.call(y), 0)
                          : y.next) &&
                      !(t = t.call(y, op[1])).done)
                  )
                    return t;
                  if (((y = 0), t)) op = [op[0] & 2, t.value];
                  switch (op[0]) {
                    case 0:
                    case 1:
                      t = op;
                      break;
                    case 4:
                      _.label++;
                      return { value: op[1], done: false };
                    case 5:
                      _.label++;
                      y = op[1];
                      op = [0];
                      continue;
                    case 7:
                      op = _.ops.pop();
                      _.trys.pop();
                      continue;
                    default:
                      if (
                        !((t = _.trys),
                        (t = t.length > 0 && t[t.length - 1])) &&
                        (op[0] === 6 || op[0] === 2)
                      ) {
                        _ = 0;
                        continue;
                      }
                      if (
                        op[0] === 3 &&
                        (!t || (op[1] > t[0] && op[1] < t[3]))
                      ) {
                        _.label = op[1];
                        break;
                      }
                      if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                      }
                      if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                      }
                      if (t[2]) _.ops.pop();
                      _.trys.pop();
                      continue;
                  }
                  op = body.call(thisArg, _);
                } catch (e) {
                  op = [6, e];
                  y = 0;
                } finally {
                  f = t = 0;
                }
              if (op[0] & 5) throw op[1];
              return { value: op[0] ? op[1] : void 0, done: true };
            }
          };
        Object.defineProperty(exports, "__esModule", { value: true });
        function getElementOffset(el) {
          var top = 0;
          var left = 0;
          var element = el;
          do {
            top += element.offsetTop || 0;
            left += element.offsetLeft || 0;
            element = element.offsetParent;
          } while (element);
          return { top: top, left: left };
        }
        var ScrollDomElement = (function () {
          function ScrollDomElement(element) {
            this.element = element;
          }
          ScrollDomElement.prototype.getHorizontalScroll = function () {
            return this.element.scrollLeft;
          };
          ScrollDomElement.prototype.getVerticalScroll = function () {
            return this.element.scrollTop;
          };
          ScrollDomElement.prototype.getMaxHorizontalScroll = function () {
            return this.element.scrollWidth - this.element.clientWidth;
          };
          ScrollDomElement.prototype.getMaxVerticalScroll = function () {
            return this.element.scrollHeight - this.element.clientHeight;
          };
          ScrollDomElement.prototype.getHorizontalElementScrollOffset =
            function (elementToScrollTo, elementToScroll) {
              return (
                getElementOffset(elementToScrollTo).left -
                getElementOffset(elementToScroll).left
              );
            };
          ScrollDomElement.prototype.getVerticalElementScrollOffset = function (
            elementToScrollTo,
            elementToScroll
          ) {
            return (
              getElementOffset(elementToScrollTo).top -
              getElementOffset(elementToScroll).top
            );
          };
          ScrollDomElement.prototype.scrollTo = function (x, y) {
            this.element.scrollLeft = x;
            this.element.scrollTop = y;
          };
          return ScrollDomElement;
        })();
        var ScrollWindow = (function () {
          function ScrollWindow() {}
          ScrollWindow.prototype.getHorizontalScroll = function () {
            return window.scrollX || document.documentElement.scrollLeft;
          };
          ScrollWindow.prototype.getVerticalScroll = function () {
            return window.scrollY || document.documentElement.scrollTop;
          };
          ScrollWindow.prototype.getMaxHorizontalScroll = function () {
            return (
              Math.max(
                document.body.scrollWidth,
                document.documentElement.scrollWidth,
                document.body.offsetWidth,
                document.documentElement.offsetWidth,
                document.body.clientWidth,
                document.documentElement.clientWidth
              ) - window.innerWidth
            );
          };
          ScrollWindow.prototype.getMaxVerticalScroll = function () {
            return (
              Math.max(
                document.body.scrollHeight,
                document.documentElement.scrollHeight,
                document.body.offsetHeight,
                document.documentElement.offsetHeight,
                document.body.clientHeight,
                document.documentElement.clientHeight
              ) - window.innerHeight
            );
          };
          ScrollWindow.prototype.getHorizontalElementScrollOffset = function (
            elementToScrollTo
          ) {
            var scrollLeft =
              window.scrollX || document.documentElement.scrollLeft;
            return scrollLeft + elementToScrollTo.getBoundingClientRect().left;
          };
          ScrollWindow.prototype.getVerticalElementScrollOffset = function (
            elementToScrollTo
          ) {
            var scrollTop =
              window.scrollY || document.documentElement.scrollTop;
            return scrollTop + elementToScrollTo.getBoundingClientRect().top;
          };
          ScrollWindow.prototype.scrollTo = function (x, y) {
            window.scrollTo(x, y);
          };
          return ScrollWindow;
        })();
        var activeAnimations = {
          elements: [],
          cancelMethods: [],
          add: function (element, cancelAnimation) {
            activeAnimations.elements.push(element);
            activeAnimations.cancelMethods.push(cancelAnimation);
          },
          remove: function (element, shouldStop) {
            if (shouldStop === void 0) {
              shouldStop = true;
            }
            var index = activeAnimations.elements.indexOf(element);
            if (index > -1) {
              if (shouldStop) {
                activeAnimations.cancelMethods[index]();
              }
              activeAnimations.elements.splice(index, 1);
              activeAnimations.cancelMethods.splice(index, 1);
            }
          },
        };
        var WINDOW_EXISTS = typeof window !== "undefined";
        var defaultOptions = {
          cancelOnUserAction: true,
          easing: function (t) {
            return --t * t * t + 1;
          },
          elementToScroll: WINDOW_EXISTS ? window : null,
          horizontalOffset: 0,
          maxDuration: 3e3,
          minDuration: 250,
          speed: 500,
          verticalOffset: 0,
        };
        function animateScrollTo(numberOrCoordsOrElement, userOptions) {
          if (userOptions === void 0) {
            userOptions = {};
          }
          return __awaiter(this, void 0, void 0, function () {
            var x,
              y,
              scrollToElement,
              options,
              isWindow,
              isElement,
              scrollBehaviorElement,
              scrollBehavior,
              elementToScroll,
              maxHorizontalScroll,
              initialHorizontalScroll,
              horizontalDistanceToScroll,
              maxVerticalScroll,
              initialVerticalScroll,
              verticalDistanceToScroll,
              horizontalDuration,
              verticalDuration,
              duration;
            return __generator(this, function (_a) {
              if (!WINDOW_EXISTS) {
                return [
                  2,
                  new Promise(function (resolve) {
                    resolve(false);
                  }),
                ];
              } else if (!window.Promise) {
                throw "Browser doesn't support Promises, and animated-scroll-to depends on it, please provide a polyfill.";
              }
              options = __assign(__assign({}, defaultOptions), userOptions);
              isWindow = options.elementToScroll === window;
              isElement = !!options.elementToScroll.nodeName;
              if (!isWindow && !isElement) {
                throw "Element to scroll needs to be either window or DOM element.";
              }
              scrollBehaviorElement = isWindow
                ? document.documentElement
                : options.elementToScroll;
              scrollBehavior = getComputedStyle(
                scrollBehaviorElement
              ).getPropertyValue("scroll-behavior");
              if (scrollBehavior === "smooth") {
                console.warn(
                  scrollBehaviorElement.tagName +
                    ' has "scroll-behavior: smooth" which can mess up with animated-scroll-to\'s animations'
                );
              }
              elementToScroll = isWindow
                ? new ScrollWindow()
                : new ScrollDomElement(options.elementToScroll);
              if (numberOrCoordsOrElement instanceof Element) {
                scrollToElement = numberOrCoordsOrElement;
                if (
                  isElement &&
                  (!options.elementToScroll.contains(scrollToElement) ||
                    options.elementToScroll.isSameNode(scrollToElement))
                ) {
                  throw "options.elementToScroll has to be a parent of scrollToElement";
                }
                x = elementToScroll.getHorizontalElementScrollOffset(
                  scrollToElement,
                  options.elementToScroll
                );
                y = elementToScroll.getVerticalElementScrollOffset(
                  scrollToElement,
                  options.elementToScroll
                );
              } else if (typeof numberOrCoordsOrElement === "number") {
                x = elementToScroll.getHorizontalScroll();
                y = numberOrCoordsOrElement;
              } else if (
                Array.isArray(numberOrCoordsOrElement) &&
                numberOrCoordsOrElement.length === 2
              ) {
                x =
                  numberOrCoordsOrElement[0] === null
                    ? elementToScroll.getHorizontalScroll()
                    : numberOrCoordsOrElement[0];
                y =
                  numberOrCoordsOrElement[1] === null
                    ? elementToScroll.getVerticalScroll()
                    : numberOrCoordsOrElement[1];
              } else {
                throw (
                  "Wrong function signature. Check documentation.\n" +
                  "Available method signatures are:\n" +
                  "  animateScrollTo(y:number, options)\n" +
                  "  animateScrollTo([x:number | null, y:number | null], options)\n" +
                  "  animateScrollTo(scrollToElement:Element, options)"
                );
              }
              x += options.horizontalOffset;
              y += options.verticalOffset;
              maxHorizontalScroll = elementToScroll.getMaxHorizontalScroll();
              initialHorizontalScroll = elementToScroll.getHorizontalScroll();
              if (x > maxHorizontalScroll) {
                x = maxHorizontalScroll;
              }
              horizontalDistanceToScroll = x - initialHorizontalScroll;
              maxVerticalScroll = elementToScroll.getMaxVerticalScroll();
              initialVerticalScroll = elementToScroll.getVerticalScroll();
              if (y > maxVerticalScroll) {
                y = maxVerticalScroll;
              }
              verticalDistanceToScroll = y - initialVerticalScroll;
              horizontalDuration = Math.abs(
                Math.round((horizontalDistanceToScroll / 1e3) * options.speed)
              );
              verticalDuration = Math.abs(
                Math.round((verticalDistanceToScroll / 1e3) * options.speed)
              );
              duration =
                horizontalDuration > verticalDuration
                  ? horizontalDuration
                  : verticalDuration;
              if (duration < options.minDuration) {
                duration = options.minDuration;
              } else if (duration > options.maxDuration) {
                duration = options.maxDuration;
              }
              return [
                2,
                new Promise(function (resolve, reject) {
                  if (
                    horizontalDistanceToScroll === 0 &&
                    verticalDistanceToScroll === 0
                  ) {
                    resolve(true);
                  }
                  activeAnimations.remove(options.elementToScroll, true);
                  var requestID;
                  var cancelAnimation = function () {
                    removeListeners();
                    cancelAnimationFrame(requestID);
                    resolve(false);
                  };
                  activeAnimations.add(
                    options.elementToScroll,
                    cancelAnimation
                  );
                  var preventDefaultHandler = function (e) {
                    return e.preventDefault();
                  };
                  var handler = options.cancelOnUserAction
                    ? cancelAnimation
                    : preventDefaultHandler;
                  var eventOptions = options.cancelOnUserAction
                    ? { passive: true }
                    : { passive: false };
                  var events = ["wheel", "touchstart", "keydown", "mousedown"];
                  var removeListeners = function () {
                    events.forEach(function (eventName) {
                      options.elementToScroll.removeEventListener(
                        eventName,
                        handler,
                        eventOptions
                      );
                    });
                  };
                  events.forEach(function (eventName) {
                    options.elementToScroll.addEventListener(
                      eventName,
                      handler,
                      eventOptions
                    );
                  });
                  var startingTime = Date.now();
                  var step = function () {
                    var timeDiff = Date.now() - startingTime;
                    var t = timeDiff / duration;
                    var horizontalScrollPosition = Math.round(
                      initialHorizontalScroll +
                        horizontalDistanceToScroll * options.easing(t)
                    );
                    var verticalScrollPosition = Math.round(
                      initialVerticalScroll +
                        verticalDistanceToScroll * options.easing(t)
                    );
                    if (
                      timeDiff < duration &&
                      (horizontalScrollPosition !== x ||
                        verticalScrollPosition !== y)
                    ) {
                      elementToScroll.scrollTo(
                        horizontalScrollPosition,
                        verticalScrollPosition
                      );
                      requestID = requestAnimationFrame(step);
                    } else {
                      elementToScroll.scrollTo(x, y);
                      cancelAnimationFrame(requestID);
                      removeListeners();
                      activeAnimations.remove(options.elementToScroll, false);
                      resolve(true);
                    }
                  };
                  requestID = requestAnimationFrame(step);
                }),
              ];
            });
          });
        }
        exports.default = animateScrollTo;
      },
      {},
    ],
    2: [
      function (require, module, exports) {
        "use strict";
        function _typeof3(obj) {
          "@babel/helpers - typeof";
          if (
            typeof Symbol === "function" &&
            _typeof3(Symbol.iterator) === "symbol"
          ) {
            _typeof3 = function _typeof(obj) {
              return typeof obj === "undefined" ? "undefined" : _typeof3(obj);
            };
          } else {
            _typeof3 = function _typeof2(obj) {
              return obj &&
                typeof Symbol === "function" &&
                obj.constructor === Symbol &&
                obj !== Symbol.prototype
                ? "symbol"
                : typeof obj === "undefined"
                ? "undefined"
                : _typeof3(obj);
            };
          }
          return _typeof3(obj);
        }
        !(function (t, e) {
          "object" ==
            (typeof exports === "undefined"
              ? "undefined"
              : _typeof3(exports)) &&
          "object" ==
            (typeof module === "undefined" ? "undefined" : _typeof3(module))
            ? (module.exports = e())
            : "function" == typeof define && define.amd
            ? define("ScrollBooster", [], e)
            : "object" ==
              (typeof exports === "undefined" ? "undefined" : _typeof3(exports))
            ? (exports.ScrollBooster = e())
            : (t.ScrollBooster = e());
        })(undefined, function () {
          return (function (t) {
            var e = {};
            function i(o) {
              if (e[o]) return e[o].exports;
              var n = (e[o] = { i: o, l: !1, exports: {} });
              return (
                t[o].call(n.exports, n, n.exports, i), (n.l = !0), n.exports
              );
            }
            return (
              (i.m = t),
              (i.c = e),
              (i.d = function (t, e, o) {
                i.o(t, e) ||
                  Object.defineProperty(t, e, { enumerable: !0, get: o });
              }),
              (i.r = function (t) {
                "undefined" != typeof Symbol &&
                  Symbol.toStringTag &&
                  Object.defineProperty(t, Symbol.toStringTag, {
                    value: "Module",
                  }),
                  Object.defineProperty(t, "__esModule", { value: !0 });
              }),
              (i.t = function (t, e) {
                if ((1 & e && (t = i(t)), 8 & e)) return t;
                if (
                  4 & e &&
                  "object" ==
                    (typeof t === "undefined" ? "undefined" : _typeof3(t)) &&
                  t &&
                  t.__esModule
                )
                  return t;
                var o = Object.create(null);
                if (
                  (i.r(o),
                  Object.defineProperty(o, "default", {
                    enumerable: !0,
                    value: t,
                  }),
                  2 & e && "string" != typeof t)
                )
                  for (var n in t) {
                    i.d(
                      o,
                      n,
                      function (e) {
                        return t[e];
                      }.bind(null, n)
                    );
                  }
                return o;
              }),
              (i.n = function (t) {
                var e =
                  t && t.__esModule
                    ? function () {
                        return t.default;
                      }
                    : function () {
                        return t;
                      };
                return i.d(e, "a", e), e;
              }),
              (i.o = function (t, e) {
                return Object.prototype.hasOwnProperty.call(t, e);
              }),
              (i.p = ""),
              i((i.s = 0))
            );
          })([
            function (t, e, i) {
              "use strict";
              function o(t, e) {
                var i = Object.keys(t);
                if (Object.getOwnPropertySymbols) {
                  var o = Object.getOwnPropertySymbols(t);
                  e &&
                    (o = o.filter(function (e) {
                      return Object.getOwnPropertyDescriptor(t, e).enumerable;
                    })),
                    i.push.apply(i, o);
                }
                return i;
              }
              function n(t) {
                for (var e = 1; e < arguments.length; e++) {
                  var i = null != arguments[e] ? arguments[e] : {};
                  e % 2
                    ? o(Object(i), !0).forEach(function (e) {
                        s(t, e, i[e]);
                      })
                    : Object.getOwnPropertyDescriptors
                    ? Object.defineProperties(
                        t,
                        Object.getOwnPropertyDescriptors(i)
                      )
                    : o(Object(i)).forEach(function (e) {
                        Object.defineProperty(
                          t,
                          e,
                          Object.getOwnPropertyDescriptor(i, e)
                        );
                      });
                }
                return t;
              }
              function s(t, e, i) {
                return (
                  e in t
                    ? Object.defineProperty(t, e, {
                        value: i,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0,
                      })
                    : (t[e] = i),
                  t
                );
              }
              function r(t, e) {
                if (!(t instanceof e))
                  throw new TypeError("Cannot call a class as a function");
              }
              function p(t, e) {
                for (var i = 0; i < e.length; i++) {
                  var o = e[i];
                  (o.enumerable = o.enumerable || !1),
                    (o.configurable = !0),
                    "value" in o && (o.writable = !0),
                    Object.defineProperty(t, o.key, o);
                }
              }
              i.r(e),
                i.d(e, "default", function () {
                  return h;
                });
              var a = function a(t) {
                  return Math.max(t.offsetHeight, t.scrollHeight);
                },
                h = (function () {
                  function t() {
                    var e =
                      arguments.length > 0 && void 0 !== arguments[0]
                        ? arguments[0]
                        : {};
                    r(this, t);
                    var i = {
                      content: e.viewport.children[0],
                      direction: "all",
                      pointerMode: "all",
                      scrollMode: void 0,
                      bounce: !0,
                      bounceForce: 0.1,
                      friction: 0.05,
                      textSelection: !1,
                      inputsFocus: !0,
                      emulateScroll: !1,
                      pointerDownPreventDefault: !0,
                      onClick: function onClick() {},
                      onUpdate: function onUpdate() {},
                      shouldScroll: function shouldScroll() {
                        return !0;
                      },
                    };
                    if (
                      ((this.props = n({}, i, {}, e)),
                      this.props.viewport &&
                        this.props.viewport instanceof Element)
                    ) {
                      if (this.props.content) {
                        (this.isDragging = !1),
                          (this.isTargetScroll = !1),
                          (this.isScrolling = !1),
                          (this.isRunning = !1);
                        var o = { x: 0, y: 0 };
                        (this.position = n({}, o)),
                          (this.velocity = n({}, o)),
                          (this.dragStartPosition = n({}, o)),
                          (this.dragOffset = n({}, o)),
                          (this.dragPosition = n({}, o)),
                          (this.targetPosition = n({}, o)),
                          (this.scrollOffset = n({}, o)),
                          (this.rafID = null),
                          (this.events = {}),
                          this.updateMetrics(),
                          this.handleEvents();
                      } else
                        console.error(
                          "ScrollBooster init error: Viewport does not have any content"
                        );
                    } else
                      console.error(
                        'ScrollBooster init error: "viewport" config property must be present and must be Element'
                      );
                  }
                  var e, i, o;
                  return (
                    (e = t),
                    (i = [
                      {
                        key: "updateOptions",
                        value: function value() {
                          var t =
                            arguments.length > 0 && void 0 !== arguments[0]
                              ? arguments[0]
                              : {};
                          (this.props = n({}, this.props, {}, t)),
                            this.props.onUpdate(this.getState()),
                            this.startAnimationLoop();
                        },
                      },
                      {
                        key: "updateMetrics",
                        value: function value() {
                          var t;
                          (this.viewport = {
                            width: this.props.viewport.clientWidth,
                            height: this.props.viewport.clientHeight,
                          }),
                            (this.content = {
                              width:
                                ((t = this.props.content),
                                Math.max(t.offsetWidth, t.scrollWidth)),
                              height: a(this.props.content),
                            }),
                            (this.edgeX = {
                              from: Math.min(
                                -this.content.width + this.viewport.width,
                                0
                              ),
                              to: 0,
                            }),
                            (this.edgeY = {
                              from: Math.min(
                                -this.content.height + this.viewport.height,
                                0
                              ),
                              to: 0,
                            }),
                            this.props.onUpdate(this.getState()),
                            this.startAnimationLoop();
                        },
                      },
                      {
                        key: "startAnimationLoop",
                        value: function value() {
                          var t = this;
                          (this.isRunning = !0),
                            cancelAnimationFrame(this.rafID),
                            (this.rafID = requestAnimationFrame(function () {
                              return t.animate();
                            }));
                        },
                      },
                      {
                        key: "animate",
                        value: function value() {
                          var t = this;
                          if (this.isRunning) {
                            this.updateScrollPosition(),
                              this.isMoving() ||
                                ((this.isRunning = !1),
                                (this.isTargetScroll = !1));
                            var e = this.getState();
                            this.setContentPosition(e),
                              this.props.onUpdate(e),
                              (this.rafID = requestAnimationFrame(function () {
                                return t.animate();
                              }));
                          }
                        },
                      },
                      {
                        key: "updateScrollPosition",
                        value: function value() {
                          this.applyEdgeForce(),
                            this.applyDragForce(),
                            this.applyScrollForce(),
                            this.applyTargetForce();
                          var t = 1 - this.props.friction;
                          (this.velocity.x *= t),
                            (this.velocity.y *= t),
                            "vertical" !== this.props.direction &&
                              (this.position.x += this.velocity.x),
                            "horizontal" !== this.props.direction &&
                              (this.position.y += this.velocity.y),
                            (this.props.bounce && !this.isScrolling) ||
                              this.isTargetScroll ||
                              ((this.position.x = Math.max(
                                Math.min(this.position.x, this.edgeX.to),
                                this.edgeX.from
                              )),
                              (this.position.y = Math.max(
                                Math.min(this.position.y, this.edgeY.to),
                                this.edgeY.from
                              )));
                        },
                      },
                      {
                        key: "applyForce",
                        value: function value(t) {
                          (this.velocity.x += t.x), (this.velocity.y += t.y);
                        },
                      },
                      {
                        key: "applyEdgeForce",
                        value: function value() {
                          if (this.props.bounce && !this.isDragging) {
                            var t = this.position.x < this.edgeX.from,
                              e = this.position.x > this.edgeX.to,
                              i = this.position.y < this.edgeY.from,
                              o = this.position.y > this.edgeY.to,
                              n = t || e,
                              s = i || o;
                            if (n || s) {
                              var r = t ? this.edgeX.from : this.edgeX.to,
                                p = i ? this.edgeY.from : this.edgeY.to,
                                a = r - this.position.x,
                                h = p - this.position.y,
                                c = {
                                  x: a * this.props.bounceForce,
                                  y: h * this.props.bounceForce,
                                },
                                l =
                                  this.position.x +
                                  (this.velocity.x + c.x) / this.props.friction,
                                u =
                                  this.position.y +
                                  (this.velocity.y + c.y) / this.props.friction;
                              ((t && l >= this.edgeX.from) ||
                                (e && l <= this.edgeX.to)) &&
                                (c.x =
                                  a * this.props.bounceForce - this.velocity.x),
                                ((i && u >= this.edgeY.from) ||
                                  (o && u <= this.edgeY.to)) &&
                                  (c.y =
                                    h * this.props.bounceForce -
                                    this.velocity.y),
                                this.applyForce({
                                  x: n ? c.x : 0,
                                  y: s ? c.y : 0,
                                });
                            }
                          }
                        },
                      },
                      {
                        key: "applyDragForce",
                        value: function value() {
                          if (this.isDragging) {
                            var t = this.dragPosition.x - this.position.x,
                              e = this.dragPosition.y - this.position.y;
                            this.applyForce({
                              x: t - this.velocity.x,
                              y: e - this.velocity.y,
                            });
                          }
                        },
                      },
                      {
                        key: "applyScrollForce",
                        value: function value() {
                          this.isScrolling &&
                            (this.applyForce({
                              x: this.scrollOffset.x - this.velocity.x,
                              y: this.scrollOffset.y - this.velocity.y,
                            }),
                            (this.scrollOffset.x = 0),
                            (this.scrollOffset.y = 0));
                        },
                      },
                      {
                        key: "applyTargetForce",
                        value: function value() {
                          this.isTargetScroll &&
                            this.applyForce({
                              x:
                                0.08 *
                                  (this.targetPosition.x - this.position.x) -
                                this.velocity.x,
                              y:
                                0.08 *
                                  (this.targetPosition.y - this.position.y) -
                                this.velocity.y,
                            });
                        },
                      },
                      {
                        key: "isMoving",
                        value: function value() {
                          return (
                            this.isDragging ||
                            this.isScrolling ||
                            Math.abs(this.velocity.x) >= 0.01 ||
                            Math.abs(this.velocity.y) >= 0.01
                          );
                        },
                      },
                      {
                        key: "scrollTo",
                        value: function value() {
                          var t =
                            arguments.length > 0 && void 0 !== arguments[0]
                              ? arguments[0]
                              : {};
                          (this.isTargetScroll = !0),
                            (this.targetPosition.x = -t.x || 0),
                            (this.targetPosition.y = -t.y || 0),
                            this.startAnimationLoop();
                        },
                      },
                      {
                        key: "setPosition",
                        value: function value() {
                          var t =
                            arguments.length > 0 && void 0 !== arguments[0]
                              ? arguments[0]
                              : {};
                          (this.velocity.x = 0),
                            (this.velocity.y = 0),
                            (this.position.x = -t.x || 0),
                            (this.position.y = -t.y || 0),
                            this.startAnimationLoop();
                        },
                      },
                      {
                        key: "getState",
                        value: function value() {
                          return {
                            isMoving: this.isMoving(),
                            isDragging: !(
                              !this.dragOffset.x && !this.dragOffset.y
                            ),
                            position: {
                              x: -this.position.x,
                              y: -this.position.y,
                            },
                            dragOffset: this.dragOffset,
                            borderCollision: {
                              left: this.position.x >= this.edgeX.to,
                              right: this.position.x <= this.edgeX.from,
                              top: this.position.y >= this.edgeY.to,
                              bottom: this.position.y <= this.edgeY.from,
                            },
                          };
                        },
                      },
                      {
                        key: "setContentPosition",
                        value: function value(t) {
                          "transform" === this.props.scrollMode &&
                            (this.props.content.style.transform = "translate("
                              .concat(-t.position.x, "px, ")
                              .concat(-t.position.y, "px)")),
                            "native" === this.props.scrollMode &&
                              ((this.props.viewport.scrollTop = t.position.y),
                              (this.props.viewport.scrollLeft = t.position.x));
                        },
                      },
                      {
                        key: "handleEvents",
                        value: function value() {
                          var t = this,
                            e = { x: 0, y: 0 },
                            i = null,
                            o = !1,
                            n = function n(i) {
                              if (t.isDragging) {
                                var n = o ? i.touches[0].pageX : i.pageX,
                                  s = o ? i.touches[0].pageY : i.pageY;
                                (t.dragOffset.x = n - e.x),
                                  (t.dragOffset.y = s - e.y),
                                  (t.dragPosition.x =
                                    t.dragStartPosition.x + t.dragOffset.x),
                                  (t.dragPosition.y =
                                    t.dragStartPosition.y + t.dragOffset.y);
                              }
                            };
                          (this.events.pointerdown = function (i) {
                            var s = (o = !(!i.touches || !i.touches[0]))
                                ? i.touches[0]
                                : i,
                              r = s.pageX,
                              p = s.pageY,
                              a = s.clientX,
                              h = s.clientY,
                              c = t.props.viewport,
                              l = c.getBoundingClientRect();
                            if (
                              !(a - l.left >= c.clientLeft + c.clientWidth) &&
                              !(h - l.top >= c.clientTop + c.clientHeight) &&
                              t.props.shouldScroll(t.getState(), i) &&
                              2 !== i.button &&
                              ("mouse" !== t.props.pointerMode || !o) &&
                              ("touch" !== t.props.pointerMode || o) &&
                              !(
                                t.props.inputsFocus &&
                                [
                                  "input",
                                  "textarea",
                                  "button",
                                  "select",
                                  "label",
                                ].indexOf(i.target.nodeName.toLowerCase()) > -1
                              )
                            ) {
                              if (t.props.textSelection) {
                                if (
                                  (function (t, e, i) {
                                    for (
                                      var o = t.childNodes,
                                        n = document.createRange(),
                                        s = 0;
                                      s < o.length;
                                      s++
                                    ) {
                                      var r = o[s];
                                      if (3 === r.nodeType) {
                                        n.selectNodeContents(r);
                                        var p = n.getBoundingClientRect();
                                        if (
                                          e >= p.left &&
                                          i >= p.top &&
                                          e <= p.right &&
                                          i <= p.bottom
                                        )
                                          return r;
                                      }
                                    }
                                    return !1;
                                  })(i.target, a, h)
                                )
                                  return;
                                (u = window.getSelection
                                  ? window.getSelection()
                                  : document.selection) &&
                                  (u.removeAllRanges
                                    ? u.removeAllRanges()
                                    : u.empty && u.empty());
                              }
                              var u;
                              (t.isDragging = !0),
                                (e.x = r),
                                (e.y = p),
                                (t.dragStartPosition.x = t.position.x),
                                (t.dragStartPosition.y = t.position.y),
                                n(i),
                                t.startAnimationLoop(),
                                t.props.pointerDownPreventDefault &&
                                  i.preventDefault();
                            }
                          }),
                            (this.events.pointermove = function (t) {
                              n(t);
                            }),
                            (this.events.pointerup = function () {
                              t.isDragging = !1;
                            }),
                            (this.events.wheel = function (e) {
                              t.props.emulateScroll &&
                                ((t.velocity.x = 0),
                                (t.velocity.y = 0),
                                (t.isScrolling = !0),
                                (t.scrollOffset.x = -e.deltaX),
                                (t.scrollOffset.y = -e.deltaY),
                                t.startAnimationLoop(),
                                clearTimeout(i),
                                (i = setTimeout(function () {
                                  return (t.isScrolling = !1);
                                }, 80)),
                                e.preventDefault());
                            }),
                            (this.events.scroll = function () {
                              var e = t.props.viewport,
                                i = e.scrollLeft,
                                o = e.scrollTop;
                              Math.abs(t.position.x + i) > 3 &&
                                ((t.position.x = -i), (t.velocity.x = 0)),
                                Math.abs(t.position.y + o) > 3 &&
                                  ((t.position.y = -o), (t.velocity.y = 0));
                            }),
                            (this.events.click = function (e) {
                              var i = t.getState(),
                                o =
                                  "vertical" !== t.props.direction
                                    ? i.dragOffset.x
                                    : 0,
                                n =
                                  "horizontal" !== t.props.direction
                                    ? i.dragOffset.y
                                    : 0;
                              Math.max(Math.abs(o), Math.abs(n)) > 5 &&
                                (e.preventDefault(), e.stopPropagation()),
                                t.props.onClick(i, e);
                            }),
                            (this.events.contentLoad = function () {
                              return t.updateMetrics();
                            }),
                            (this.events.resize = function () {
                              return t.updateMetrics();
                            }),
                            this.props.viewport.addEventListener(
                              "mousedown",
                              this.events.pointerdown
                            ),
                            this.props.viewport.addEventListener(
                              "touchstart",
                              this.events.pointerdown
                            ),
                            this.props.viewport.addEventListener(
                              "click",
                              this.events.click
                            ),
                            this.props.viewport.addEventListener(
                              "wheel",
                              this.events.wheel
                            ),
                            this.props.viewport.addEventListener(
                              "scroll",
                              this.events.scroll
                            ),
                            this.props.content.addEventListener(
                              "load",
                              this.events.contentLoad,
                              !0
                            ),
                            window.addEventListener(
                              "mousemove",
                              this.events.pointermove
                            ),
                            window.addEventListener(
                              "touchmove",
                              this.events.pointermove
                            ),
                            window.addEventListener(
                              "mouseup",
                              this.events.pointerup
                            ),
                            window.addEventListener(
                              "touchend",
                              this.events.pointerup
                            ),
                            window.addEventListener(
                              "resize",
                              this.events.resize
                            );
                        },
                      },
                      {
                        key: "destroy",
                        value: function value() {
                          this.props.viewport.removeEventListener(
                            "mousedown",
                            this.events.pointerdown
                          ),
                            this.props.viewport.removeEventListener(
                              "touchstart",
                              this.events.pointerdown
                            ),
                            this.props.viewport.removeEventListener(
                              "click",
                              this.events.click
                            ),
                            this.props.viewport.removeEventListener(
                              "wheel",
                              this.events.wheel
                            ),
                            this.props.viewport.removeEventListener(
                              "scroll",
                              this.events.scroll
                            ),
                            this.props.content.removeEventListener(
                              "load",
                              this.events.contentLoad
                            ),
                            window.removeEventListener(
                              "mousemove",
                              this.events.pointermove
                            ),
                            window.removeEventListener(
                              "touchmove",
                              this.events.pointermove
                            ),
                            window.removeEventListener(
                              "mouseup",
                              this.events.pointerup
                            ),
                            window.removeEventListener(
                              "touchend",
                              this.events.pointerup
                            ),
                            window.removeEventListener(
                              "resize",
                              this.events.resize
                            );
                        },
                      },
                    ]) && p(e.prototype, i),
                    o && p(e, o),
                    t
                  );
                })();
            },
          ]).default;
        });
      },
      {},
    ],
    3: [
      function (require, module, exports) {
        "use strict";
        var _header = require("./view/_header");
        var _header2 = _interopRequireDefault(_header);
        var _loading = require("./view/_loading");
        var _loading2 = _interopRequireDefault(_loading);
        var _modal = require("./view/_modal");
        var _modal2 = _interopRequireDefault(_modal);
        var _smooth = require("./view/_smooth");
        var _smooth2 = _interopRequireDefault(_smooth);
        var _drag = require("./view/_drag");
        var _drag2 = _interopRequireDefault(_drag);
        var _scrollboosterMin = require("./libs/scrollbooster.min.js.js");
        var _scrollboosterMin2 = _interopRequireDefault(_scrollboosterMin);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
      },
      {
        "./libs/scrollbooster.min.js": 2,
        "./view/_drag": 4,
        "./view/_header": 5,
        "./view/_loading": 6,
        "./view/_modal": 7,
        "./view/_smooth": 8,
      },
    ],
    4: [
      function (require, module, exports) {
        "use strict";
        jQuery.prototype.mousedragscrollable = function () {
          var target = void 0;
          $(this).each(function (i, e) {
            $(e).mousedown(function (event) {
              event.preventDefault();
              target = $(e);
              $(e).data({
                down: true,
                move: false,
                x: event.clientX,
                y: event.clientY,
                scrollleft: $(e).scrollLeft(),
                scrolltop: $(e).scrollTop(),
              });
              return false;
            });
            $(e).click(function (event) {
              if ($(e).data("move")) {
                return false;
              }
            });
          });
          $(document)
            .mousemove(function (event) {
              if ($(target).data("down")) {
                event.preventDefault();
                var move_x = $(target).data("x") - event.clientX;
                var move_y = $(target).data("y") - event.clientY;
                if (move_x !== 0 || move_y !== 0) {
                  $(target).data("move", true);
                } else {
                  return;
                }
                $(target).scrollLeft($(target).data("scrollleft") + move_x);
                $(target).scrollTop($(target).data("scrolltop") + move_y);
                return false;
              }
            })
            .mouseup(function (event) {
              $(target).data("down", false);
              return false;
            });
        };
        $("html").mousedragscrollable();
      },
      {},
    ],
    5: [
      function (require, module, exports) {
        "use strict";
        $("#js-hamburger").click(function () {
          $(this).toggleClass("is-open");
          $(".l-navigation").toggleClass("is-open");
          $("html").toggleClass("is-fixed");
        });
      },
      {},
    ],
    6: [
      function (require, module, exports) {
        "use strict";
        $(window).on("load", function () {
          resizeBg();
          $("html").addClass("is-fixed");
          var _content = $("#p-marcheLoading");
          var loadingImgs = $(".c-loadingImg");
          var waitTime = 0;
          var _loop = function _loop(i) {
            var obj = loadingImgs.eq(i);
            let time = 100;
            waitTime = time + (i + 1) * time;
            setTimeout(function () {
              obj.show();
              if (i != 0) {
                loadingImgs.eq(i - 1).hide();
              }
            }, waitTime);
          };
          for (var i = 0; i < loadingImgs.length; i++) {
            _loop(i);
          }
          let waitTime2 = 750;
          setTimeout(function () {
            if (window.innerWidth <= 767) {
              loadingImgs.css({ transform: "scale(7.5)" });
              window.scrollTo("2260", "460");
            } else {
              loadingImgs.css({ transform: "scale(1.5)" });
              window.scrollTo("1500", "400");
            }
          }, waitTime2);
          setTimeout(function () {
            _content.addClass("-done");
            $("html").removeClass("is-fixed");
          }, waitTime2 + 250);
          setTimeout(function () {
            $(".p-marcheContents__wrapper").animate({ opacity: "1" }, 500);
          }, waitTime2 + 750);
          setTimeout(function () {
            $(".l-btnOpenTownMap").animate({ opacity: "1" }, 500);
          }, waitTime2 + 1000);
          setTimeout(function () {
            $(".p-marche__figure").animate({ opacity: "1" }, 1e3);
          }, waitTime2 + 1250);
          setTimeout(function () {
            $(".p-marche__frame__arrow").animate({ opacity: "0" }, 1e3);
          }, waitTime2 + 5000);
        });
        $(window).resize(function () {
          resizeBg();
        });
        document.documentElement.addEventListener(
          "touchstart",
          function (e) {
            if (e.touches.length >= 2) {
              e.preventDefault();
            }
          },
          { passive: false }
        );
        function resizeBg() {
          var _vh = window.innerHeight;
          var _vw = window.innerWidth;
          var _frameH = (_vw * 1334) / 750;
          var _frameW = (_vh * 750) / 1334;
          var SPNUM = 559;
          if (_vw > SPNUM) {
            _frameH = (_vw * 2) / 3;
            _frameW = (_vh * 3) / 2;
          }
          var _bgH = (_vh - _frameH) / 2;
          var _bgW = (_vw - _frameW) / 2;
          _frameH = _vh - (_bgH > 0 ? _bgH : 0) * 2;
          _frameW = _vw - (_bgW > 0 ? _bgW : 0) * 2;
          var _bgTop = $(".p-marche__frame__outer" + ".-top");
          var _bgBottom = $(".p-marche__frame__outer" + ".-bottom");
          var _bgLeft = $(".p-marche__frame__outer" + ".-left");
          var _bgRight = $(".p-marche__frame__outer" + ".-right");
          _bgTop.css({ height: _bgH + 1 });
          _bgTop.css({ width: _vw });
          _bgBottom.css({ height: _bgH + 1 });
          _bgBottom.css({ width: _vw });
          _bgLeft.css({ height: _vh });
          _bgLeft.css({ width: _bgW });
          _bgRight.css({ height: _vh });
          _bgRight.css({ width: _bgW });
          var _modalCulture = $(".c-modal__body" + ".-culture");
          var _cultureL = (_bgW > 0 ? _bgW : 0) + _frameW * 0.08;
          var _cultureB = (_bgH > 0 ? _bgH : 0) + _frameH * 0.09;
          var _cultureW = _frameW * 0.4;
          var _cultureH = _frameH * 0.8;
          _modalCulture.css({ top: "50%" });
          _modalCulture.css({ left: "0%" });
          _modalCulture.css({ width: "100%" });
          _modalCulture.css({ height: "100%" });
          var SEMINNUM = 595;
          if (_vh > 530) {
            _modalCulture.css({ height: "90%" });
          }
          if (_vh > SEMINNUM) {
            _modalCulture.css({ height: "80%" });
          }
          var _modalCultureImg = $(".c-modal__culture__img");
          var _modalCultureTitle = $(".c-modal__culture__title");
          var _modalCultureText = $(".c-modal__culture__text");
          _modalCultureImg.css({ width: "75%" });
          _modalCultureTitle.css({ "font-size": "24px" });
          _modalCultureText.css({ "font-size": "15px" });
          if (_vw > SPNUM) {
            _modalCulture.css({ top: "unset" });
            _modalCulture.css({ bottom: _cultureB });
            _modalCulture.css({ left: _cultureL });
            _modalCulture.css({ width: _cultureW });
            _modalCulture.css({ height: _cultureH });
            _modalCultureImg.css({ width: "65%" });
            if (_cultureW < 340) {
              _modalCultureImg.css({ width: "50%" });
              _modalCultureTitle.css({ "font-size": "20px" });
              _modalCultureText.css({ "font-size": "15px" });
            }
            if (_cultureW < 328) {
              _modalCultureImg.css({ width: "50%" });
              _modalCultureTitle.css({ "font-size": "20px" });
              _modalCultureText.css({ "font-size": "14px" });
            }
            if (_cultureW < 260) {
              _modalCultureImg.css({ width: "50%" });
              _modalCultureTitle.css({ "font-size": "16px" });
              _modalCultureText.css({ "font-size": "8px" });
            }
          }
          var _modalRecipe = $(".c-modal__body" + ".-recipe");
          _modalRecipe.css({ "margin-top": _bgH > 0 ? _bgH : 0 });
          if (_vw > 428) {
            _modalRecipe.css({ "margin-top": 0 });
          }
          var _modalContentsRecipe = $(".c-modal__content" + ".-recipe");
          var _modalContentsRecipeW = (_frameW > _vw ? _vw : _frameW) * 0.8;
          var _modalContentsRecipeH = (_frameH > _vh ? _vh : _frameH) * 0.65;
          _modalContentsRecipe.css({ width: _modalContentsRecipeW });
          _modalContentsRecipe.css({ height: _modalContentsRecipeH });
          if (_vw > 768) {
            _modalContentsRecipe.css({ width: "70%" });
            _modalContentsRecipe.css({ height: "75%" });
          }
          var _modalContentsRecipePerson = $(".c-modal__recipe__person");
          var _modalContentsRecipePersonH =
            (_frameH > _vh ? _vh : _frameH) * 0.35;
          if (_vw <= SPNUM) {
            _modalContentsRecipe.css({ height: _vh * 0.7 });
            if (_vh <= 850) {
              _modalContentsRecipe.css({ height: _vh * 0.82 });
            }
            if (_vh <= 680) {
              _modalContentsRecipe.css({ height: _vh * 0.85 });
            }
          }
          var _modalContentsRecipeMaterialLi = $(
            ".c-modal__recipe__material__inner li"
          ).first();
          var _modalContentsRecipeMaterialImgSize =
            _modalContentsRecipeMaterialLi.width();
          var _modalContentsRecipeMaterialImg = $(
            ".c-modal__recipe__material__inner img"
          );
          _modalContentsRecipeMaterialImg.css({
            height: _modalContentsRecipeMaterialImgSize,
          });
          _modalContentsRecipeMaterialImg.css({
            width: _modalContentsRecipeMaterialImgSize,
          });
          var _modalMovie = $(".c-modal__body" + ".-movie");
          var _modalMovieT = (_bgH > 0 ? _bgH : 0) + _frameH * 0.15;
          if (_vw <= SPNUM) {
            _modalMovieT = _vh * 0.35;
          }
          _modalMovie.css({ top: _modalMovieT });
          var _modalContentsMovie = $(".c-modal__content" + ".-movie");
          var _modalContentsMovieW = (_frameW > _vw ? _vw : _frameW) * 0.8;
          var _modalContentsMovieH = (_frameH > _vh ? _vh : _frameH) * 0.7;
          if (_vw <= SPNUM) {
            _modalContentsMovieW = _vw * 0.6;
            _modalContentsMovieH = "auto";
          }
          if (_vw <= 480) {
            _modalContentsMovieW = _vw * 0.8;
            _modalContentsMovieH = "auto";
          }
          _modalContentsMovie.css({ width: _modalContentsMovieW });
          _modalContentsMovie.css({ height: _modalContentsMovieH });
          var qqq = (_bgW > 0 ? _bgW : 0) + _frameW * 0.03;
          var www = (_bgW > 0 ? _bgW : 0) + _frameW * 0.05;
          var _leftStartNum = qqq + "px";
          var _leftEndNum = www + "px";
          var _rightStartNum = qqq + 20 + "px";
          var _rightEndNum = www + 20 + "px";
          $(":root")[0].style.setProperty(
            "--arrow--left--start",
            _leftStartNum
          );
          $(":root")[0].style.setProperty("--arrow--left--end", _leftEndNum);
          $(":root")[0].style.setProperty(
            "--arrow--right--start",
            _rightStartNum
          );
          $(":root")[0].style.setProperty("--arrow--right--end", _rightEndNum);
          var _btnOpenTownMap = $(".l-btnOpenTownMap");
        }
        document.addEventListener("touchstart", function () {}, false);
        document.addEventListener("gesturestart", function () {}, false);
        document.addEventListener("gesturechange", function () {}, false);
        document.addEventListener("gestureend", function () {}, false);
      },
      {},
    ],
    7: [
      function (require, module, exports) {
        "use strict";
        var _animatedScrollTo = require("animated-scroll-to");
        var _animatedScrollTo2 = _interopRequireDefault(_animatedScrollTo);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        $(".js-modalOpen_movie").click(function () {
          var _modal = $(".c-modal__body" + ".-movie");
          var dataSetName = $(this).data("target");
          $(".c-modal__content__movie").children().hide();
          var iframe = void 0;
          var player = void 0;
          if (dataSetName == "osaka") {
            $(".c-modal__content__movie > .-osaka").show();
            iframe = $(".c-modal__content__movie > .-osaka > iframe");
          } else if (dataSetName == "middleEast") {
            $(".c-modal__content__movie > .-middleEast").show();
            iframe = $(".c-modal__content__movie > .-middleEast> iframe");
          } else if (dataSetName == "america") {
            $(".c-modal__content__movie > .-america").show();
            iframe = $(".c-modal__content__movie > .-america > iframe");
          } else if (dataSetName == "hongkong") {
            $(".c-modal__content__movie > .-hongkong").show();
            iframe = $(".c-modal__content__movie > .-hongkong > iframe");
          } else if (dataSetName == "italy") {
            $(".c-modal__content__movie > .-italy").show();
            iframe = $(".c-modal__content__movie > .-italy > iframe");
          }
          player = new Vimeo.Player(iframe);
          player
            .play()
            .then(function () {})
            .catch(function (error) {});
          player.on("play", function () {});
          _modal.fadeIn(1e3);
          _modal.addClass("is-show");
          $("body").append('<div class="c-modal__overlay"></div>');
          $(".c-modal__overlay").fadeIn("slow");
          $("html").addClass("is-fixed");
          $(".c-modal__overlay, .js-modalClose")
            .unbind()
            .click(function () {
              player.on("ended", function (data) {});
              $("html").removeClass("is-fixed");
              $(".c-modal__body,.c-modal__overlay").fadeOut(
                "slow",
                function () {
                  $(".c-modal__overlay").remove();
                  _modal.removeClass("is-show");
                }
              );
            });
        });
        $(".js-modalOpen_culture").click(function () {
          var obj = $(this);
          var srcId = obj.data("id");
          var srcTitle = obj.data("title");
          var srcText = obj.data("text");
          // var imagePath = "./assets/img/marche/popup_" + srcId + ".png?$staticlink$";
          var imagePath = "https://cdn.shopify.com/s/files/1/0605/2803/3958/files/vt-trip-marche_" + srcId + ".png?$staticlink$";
          var _modal = $(".c-modal__body" + ".-culture");
          var _image = _modal.find(".c-modal__culture__img").attr("src");
          var _title = _modal.find(".c-modal__culture__title").text();
          _modal.find(".c-modal__culture__title").text(srcTitle);
          _modal.find(".c-modal__culture__text").text(srcText);
          _modal.find(".c-modal__culture__img").attr("src", imagePath);
          _modal.fadeIn(1e3);
          _modal.addClass("is-show");
          $("body").append('<div class="c-modal__overlay"></div>');
          $(".c-modal__overlay").fadeIn("slow");
          if (window.innerWidth > 559) {
            $(".c-modal__overlay").css(
              "background-color",
              "rgba(0, 0, 0, 0.00)"
            );
          }
          $("html").addClass("is-fixed");
          var _positionY = obj.position().top - window.innerHeight / 2;
          var _positionX = obj.position().left - window.innerWidth / 2;
          (0, _animatedScrollTo2.default)([_positionX, _positionY]);
          $(".c-modal__overlay, .js-modalClose")
            .unbind()
            .click(function () {
              $("html").removeClass("is-fixed");
              $(".c-modal__body,.c-modal__overlay").fadeOut(
                "slow",
                function () {
                  $(".c-modal__overlay").remove();
                  _modal.removeClass("is-show");
                }
              );
            });
        });
        $(".js-modalOpen_recipe").click(function () {
          var _modal = $(".c-modal__body" + ".-recipe");
          // var imgPath = "./assets/img/marche/recipe/";
          var imgPath = "https://cdn.shopify.com/s/files/1/0605/2803/3958/files/";
          var recipeDataList = {
            beefTongue: {
              category: "メインディッシュ",
              title: "牛タンステーキ～ハーブ仕立て～",
              imagesAndMoviesList: [imgPath + "beefTongue_main.jpg?$staticlink$"],
              person: {
                img: imgPath + "beefTongue_person.jpg?$staticlink$",
                job: "フードコーディネーター・調理師",
                name: "内田有紀",
                text: " 都内料理店でシェフとして働いた後、メニュー開発や撮影に興味が沸き、専門学校講師、フードコーディネーターとして活躍する。現在は子育てをしながら活動中。子供向けレシピや、おつまみ等のレシピ開発が得意。",
              },
              story:
                "各地の焼肉店で食べるタン塩と仙台名物の牛たんは似て非なるもの・・・仙台で愛される名物牛たんをシンプルにハーブ仕立てのステーキに仕上げました。素材の良さを活かしたご家庭でも調理しやすい一品です。",
              volume: "2人分",
              materialList: [
                {
                  img: imgPath + "beefTongue_ingredient01.jpg?$staticlink$",
                  name: "牛タンたん塩仕込み（12㎜）",
                  volume: "200g",
                },
                {
                  img: imgPath + "beefTongue_ingredient02.jpg?$staticlink$",
                  name: "A）ローズマリー",
                  volume: "2本",
                },
                {
                  img: imgPath + "beefTongue_ingredient03.jpg?$staticlink$",
                  name: "A）タイム",
                  volume: "5本程度",
                },
                {
                  img: imgPath + "beefTongue_ingredient04.jpg?$staticlink$",
                  name: "A）オリーブオイル",
                  volume: "大さじ1",
                },
                {
                  img: imgPath + "beefTongue_ingredient05.jpg?$staticlink$",
                  name: "A）にんにく",
                  volume: "1かけ",
                },
                {
                  img: imgPath + "beefTongue_ingredient06.jpg?$staticlink$",
                  name: "舞茸",
                  volume: "1パック",
                },
                {
                  img: imgPath + "beefTongue_ingredient07.jpg?$staticlink$",
                  name: "パプリカ",
                  volume: "1/4個",
                },
                {
                  img: imgPath + "beefTongue_ingredient08.jpg?$staticlink$",
                  name: "黄カリフラワー",
                  volume: "1/4個",
                },
                {
                  img: imgPath + "beefTongue_ingredient09.jpg?$staticlink$",
                  name: "レモンスライス",
                  volume: "1/4個",
                },
              ],
              howTo: {
                text: "牛タンを塩仕込みし、こんがりと焼く。野菜と盛り付けたらできあがり！ハーブはある物でOK！ドライでも◎。付け合わせの野菜はお好みでどうぞ",
                time: "所要時間　15分（つけこみの時間は除く）",
                contentsList: [
                  {
                    img: imgPath + "beefTongue_process01.jpg?$staticlink$",
                    num: "1",
                    text: "牛たん塩仕込み（12㎜）はAを揉みこみ、15分～1時間ほどおく。焼く前に冷蔵庫から取り出し、常温に近い状態にしておく。",
                  },
                  {
                    img: imgPath + "beefTongue_process02.jpg?$staticlink$",
                    num: "2",
                    text: "舞茸は小房に分ける。パプリカは種を取り、一口大に切る。黄カリフラワーは小房に分け、柔らかく茹でる。",
                  },
                  {
                    img: imgPath + "beefTongue_process03.jpg?$staticlink$",
                    num: "3",
                    text: "フライパンを熱し、①を両面きつね色になるまで焼く。",
                  },
                  {
                    img: imgPath + "beefTongue_process04.jpg?$staticlink$",
                    num: "4",
                    text: "③のフライパンに②をのせ、こんがりと焼く。",
                  },
                  {
                    img: imgPath + "beefTongue_process05.jpg?$staticlink$",
                    num: "5",
                    text: "器に③と④を彩りよく盛り付ける。",
                  },
                ],
              },
            },
            spinyLobster: {
              category: "メインディッシュ",
              title: "伊勢海老アヒージョのパスタ",
              imagesAndMoviesList: [
                imgPath + "spinyLobster_main01.jpg?$staticlink$",
                imgPath + "spinyLobster_main02.jpg?$staticlink$",
              ],
              person: {
                img: imgPath + "spinyLobster_person.jpg?$staticlink$",
                job: "料理家",
                name: "ちはな",
                text: " 5才の息子の母。家族につくるおうちごはんとお弁当や心と胃袋を掴むおモテなし料理の考案。\t料理教室も開催中。",
              },
              story:
                "レトルトのアヒージョでも侮るなかれ 簡単10分で出来る高級レストラン級の味！",
              volume: "2人分",
              materialList: [
                {
                  img: imgPath + "spinyLobster_ingredient01.jpg?$staticlink$",
                  name: "伊勢海老アヒージョ",
                  volume: "1袋",
                },
                {
                  img: imgPath + "spinyLobster_ingredient02.jpg?$staticlink$",
                  name: "パスタ麺",
                  volume: "100g",
                },
                {
                  img: imgPath + "spinyLobster_ingredient03.jpg?$staticlink$",
                  name: "マッシュルーム",
                  volume: "2個",
                },
                {
                  img: imgPath + "spinyLobster_ingredient04.jpg?$staticlink$",
                  name: "インゲン豆",
                  volume: "4本",
                },
                {
                  img: imgPath + "spinyLobster_ingredient05.jpg?$staticlink$",
                  name: "ミニトマト",
                  volume: "2個",
                },
                {
                  img: imgPath + "spinyLobster_ingredient06.jpg?$staticlink$",
                  name: "その他お好みの野菜",
                  volume: "適量",
                },
              ],
              howTo: {
                text: "炒めた野菜と伊勢海老アヒージョにゆでたパスタとゆで汁を混ぜ合わせるだけの簡単レシピ！",
                time: "所要時間　10分",
                contentsList: [
                  {
                    img: imgPath + "spinyLobster_process01.jpg?$staticlink$",
                    num: "1",
                    text: "お好みの野菜を食べやすい大きさに切る<br>★今回はマッシュルームを4等分にし、いんげん豆は筋を取り3cm幅に切る、ミニトマトは半分に切ってます。",
                  },
                  {
                    img: imgPath + "spinyLobster_process02.jpg?$staticlink$",
                    num: "2",
                    text: "パスタを茹でるお湯を沸かし、水の量に対して1%の塩を入れパスタ麺を茹でる",
                  },
                  {
                    img: imgPath + "spinyLobster_process03.jpg?$staticlink$",
                    num: "3",
                    text: "フライパンにオリーブオイルを熱し、野菜を炒める<br>★火の通りにくい野菜から炒めると良いです◎",
                  },
                  {
                    img: imgPath + "spinyLobster_process04.jpg?$staticlink$",
                    num: "4",
                    text: "3に火が通ったら、伊勢海老のアヒージョを入れて野菜に馴染んだら火を止める",
                  },
                  {
                    img: imgPath + "spinyLobster_process05.jpg?$staticlink$",
                    num: "5",
                    text: "パスタ麺が茹であがったらフライパンの中に加え、茹で汁を150mLも入れて混ぜ合わせ、お皿に盛り付ける",
                  },
                ],
              },
            },
            oilSabadines: {
              category: "ランチ",
              title: "オイルサバディンのカレーピラフ",
              imagesAndMoviesList: [
                imgPath + "oilSabadines_main01.jpg?$staticlink$",
                imgPath + "oilSabadines_main02.jpg?$staticlink$",
              ],
              person: {
                img: imgPath + "oilSabadines_person.jpg?$staticlink$",
                job: "料理家",
                name: "ちはな",
                text: " 5才の息子の母。家族につくるおうちごはんとお弁当や心と胃袋を掴むおモテなし料理の考案。\t料理教室も開催中。",
              },
              story:
                "炊飯器で作れる簡単おしゃれレシピ！野菜もたっぷり入っているので、健康にも良い美味グルメです",
              volume: "4人分",
              materialList: [
                {
                  img: imgPath + "oilSabadines_ingredient01.jpg?$staticlink$",
                  name: "オイルサバディン",
                  volume: "1缶",
                },
                {
                  img: imgPath + "oilSabadines_ingredient02.jpg?$staticlink$",
                  name: "米",
                  volume: "2合",
                },
                {
                  img: imgPath + "oilSabadines_ingredient03.jpg?$staticlink$",
                  name: "玉ねぎ",
                  volume: "1/4",
                },
                {
                  img: imgPath + "oilSabadines_ingredient04.jpg?$staticlink$",
                  name: "にんじん",
                  volume: "30g",
                },
                {
                  img: imgPath + "oilSabadines_ingredient05.jpg?$staticlink$",
                  name: "しめじ",
                  volume: "50g",
                },
                {
                  img: imgPath + "oilSabadines_ingredient06.jpg?$staticlink$",
                  name: "スイートコーン",
                  volume: "60g",
                },
                {
                  img: imgPath + "oilSabadines_ingredient07.jpg?$staticlink$",
                  name: "だし醤油",
                  volume: "大さじ1",
                },
                {
                  img: imgPath + "oilSabadines_ingredient08.jpg?$staticlink$",
                  name: "水",
                  volume: "360ml",
                },
                {
                  img: imgPath + "oilSabadines_ingredient09.jpg?$staticlink$",
                  name: "コンソメ",
                  volume: "6g",
                },
                {
                  img: imgPath + "oilSabadines_ingredient10.jpg?$staticlink$",
                  name: "カレー粉",
                  volume: "大さじ1",
                },
                {
                  img: imgPath + "oilSabadines_ingredient11.jpg?$staticlink$",
                  name: "バター",
                  volume: "10g",
                },
              ],
              howTo: {
                text: "野菜を切ってバター以外の全ての材料を入れて炊飯。炊けたら1分蒸らしてバターと混ぜ合わせる。お好みでパセリをまぶしたら完成！",
                time: "所要時間　10分＋炊飯時間",
                contentsList: [
                  {
                    img: imgPath + "oilSabadines_process01.jpg?$staticlink$",
                    num: "1",
                    text: "にんじんを5mm幅の角切りにし、玉ねぎは1cm幅の角切りにし、しめじは根を切ってバラバラにする",
                  },
                  {
                    img: imgPath + "oilSabadines_process02.jpg?$staticlink$",
                    num: "2",
                    text: "洗ったお米に、バター以外のすべての材料を入れて炊飯する",
                  },
                  {
                    img: imgPath + "oilSabadines_process03.jpg?$staticlink$",
                    num: "3",
                    text: "炊けたら混ぜ合わせて1分蒸らし、バターを加えてバターが全体に馴染むまで混ぜ合わせ、お皿に盛り付け、お好みで刻みパセリをかける",
                  },
                ],
              },
            },
            satsumaBeef: {
              category: "メインディッシュ",
              title: "さつま福永牛のミルフィーユカツレツ",
              imagesAndMoviesList: [
                imgPath + "satsumaBeef_main01.jpg?$staticlink$",
                "https://vimeo.com/659210834",
              ],
              person: {
                img: imgPath + "oilSabadines_person.jpg?$staticlink$",
                job: "料理家",
                name: "ちはな",
                text: " 5才の息子の母。家族につくるおうちごはんとお弁当や心と胃袋を掴むおモテなし料理の考案。\t料理教室も開催中。",
              },
              story:
                "トマト缶であっという間におしゃれなイタリアン料理が完成<br>こだわりのさつま福永牛を使った絶品簡単レシピです",
              volume: "2人分",
              materialList: [
                {
                  img: imgPath + "satsumaBeef_ingredient01.jpg?$staticlink$",
                  name: "さつま福永牛",
                  volume: "300g",
                },
                {
                  img: imgPath + "satsumaBeef_ingredient02.jpg?$staticlink$",
                  name: "塩コショウ",
                  volume: "少々",
                },
                {
                  img: imgPath + "satsumaBeef_ingredient03.jpg?$staticlink$",
                  name: "卵",
                  volume: "1個",
                },
                {
                  img: imgPath + "satsumaBeef_ingredient04.jpg?$staticlink$",
                  name: "パン粉",
                  volume: "約70g",
                },
                {
                  img: imgPath + "satsumaBeef_ingredient05.jpg?$staticlink$",
                  name: "パルメザンチーズ",
                  volume: "少々",
                },
                {
                  img: imgPath + "satsumaBeef_ingredient06.jpg?$staticlink$",
                  name: "玉ねぎ",
                  volume: "1/4玉",
                },
                {
                  img: imgPath + "satsumaBeef_ingredient07.jpg?$staticlink$",
                  name: "にんにく",
                  volume: "1かけ",
                },
                {
                  img: imgPath + "satsumaBeef_ingredient08.jpg?$staticlink$",
                  name: "トマトホール缶",
                  volume: "1缶",
                },
                {
                  img: imgPath + "satsumaBeef_ingredient09.jpg?$staticlink$",
                  name: "塩",
                  volume: "小さじ1/3",
                },
                {
                  img: imgPath + "satsumaBeef_ingredient10.jpg?$staticlink$",
                  name: "バター",
                  volume: "10g",
                },
                {
                  img: imgPath + "satsumaBeef_ingredient11.jpg?$staticlink$",
                  name: "砂糖",
                  volume: "小さじ1",
                },
                {
                  img: imgPath + "satsumaBeef_ingredient12.jpg?$staticlink$",
                  name: "バジルの葉",
                  volume: "約5枚",
                },
                {
                  img: imgPath + "satsumaBeef_ingredient13.jpg?$staticlink$",
                  name: "クレソン",
                  volume: "少々",
                },
                {
                  img: imgPath + "satsumaBeef_ingredient14.jpg?$staticlink$",
                  name: "フルーツトマト",
                  volume: "1個",
                },
                {
                  img: imgPath + "satsumaBeef_ingredient15.jpg?$staticlink$",
                  name: "レモン",
                  volume: "1枚",
                },
              ],
              howTo: {
                text: "調味料を混ぜてトマトソースを作る。牛肉を数枚重ね合わせて塩コショウで味付けし、衣をつけて170℃で5分ほど揚げる。お皿に盛り付けてトマトソースとパルメザンチーズをかけて出来上がり",
                time: "所要時間　30分",
                contentsList: [
                  {
                    img: imgPath + "satsumaBeef_process01.jpg?$staticlink$",
                    num: "1",
                    text: "玉ねぎとにんにくをみじん切りにする",
                  },
                  {
                    img: imgPath + "satsumaBeef_process02.jpg?$staticlink$",
                    num: "2",
                    text: "バジルの葉をざっくり刻む",
                  },
                  {
                    img: imgPath + "satsumaBeef_process03.jpg?$staticlink$",
                    num: "3",
                    text: "トマトのホール缶を手でつぶす（またはミキサーでつぶす）",
                  },
                  {
                    img: imgPath + "satsumaBeef_process04.jpg?$staticlink$",
                    num: "4",
                    text: "炒め油をひいたフライパンに1と塩を入れて炒める",
                  },
                  {
                    img: imgPath + "satsumaBeef_process05.jpg?$staticlink$",
                    num: "5",
                    text: "玉ねぎがしんなりした頃に、トマトホール缶を加えて2/3の量になるまで5分ほど弱火で煮詰める<br>★塩を先に加えることで野菜の甘みが増します",
                  },
                  {
                    img: imgPath + "satsumaBeef_process06.jpg?$staticlink$",
                    num: "6",
                    text: "トマトソースが煮詰まったらバターと砂糖を加え、バターが溶けたら火を止めてバジルの葉を加える",
                  },
                  {
                    img: imgPath + "satsumaBeef_process07.jpg?$staticlink$",
                    num: "7",
                    text: "カツレツ1枚につき福永牛を10枚程度重ねて、塩胡椒をふる",
                  },
                  {
                    img: imgPath + "satsumaBeef_process08.jpg?$staticlink$",
                    num: "8",
                    text: "ボウルに卵と小麦粉を入れて混ぜ合わせ、バッター液を作り、福永牛を重ねたものにバッター液を馴染ませ、パン粉をまぶす",
                  },
                  {
                    img: imgPath + "satsumaBeef_process09.jpg?$staticlink$",
                    num: "9",
                    text: "170℃の揚げ油でたまにひっくり返しながら5分ほど揚げる",
                  },
                  {
                    img: imgPath + "satsumaBeef_process10.jpg?$staticlink$",
                    num: "10",
                    text: "お皿に付け合わせを盛り付け、カツレツをのせ、トマトソースをかけ、パルメザンチーズを振る",
                  },
                ],
              },
            },
            cohoSalmon: {
              category: "メインディッシュ",
              title: "紅鮭ときのこのパエリア",
              imagesAndMoviesList: [imgPath + "cohoSalmon_main.jpg?$staticlink$"],
              person: {
                img: imgPath + "recipe_profile_alt.png?$staticlink$",
                job: "ナチュラルフードコーディネーター",
                name: "あや",
                text: "九州在住。<br>日々の暮らしの中で、身体に優しいご飯とおやつ作りを心掛けている。",
              },
              story: "天然の紅鮭を使用した本格パエリア。",
              volume: "4人分",
              materialList: [
                {
                  img: imgPath + "cohoSalmon_ingredient01.jpg?$staticlink$",
                  name: "米",
                  volume: "2合",
                },
                {
                  img: imgPath + "cohoSalmon_ingredient02.jpg?$staticlink$",
                  name: "紅鮭",
                  volume: "4切れ",
                },
                {
                  img: imgPath + "cohoSalmon_ingredient03.jpg?$staticlink$",
                  name: "ハーブソルト",
                  volume: "少々",
                },
                {
                  img: imgPath + "cohoSalmon_ingredient04.jpg?$staticlink$",
                  name: "ブラックペッパーパウダー",
                  volume: "少々",
                },
                {
                  img: imgPath + "cohoSalmon_ingredient05.jpg?$staticlink$",
                  name: "にんにく",
                  volume: "1かけ",
                },
                {
                  img: imgPath + "cohoSalmon_ingredient06.jpg?$staticlink$",
                  name: "玉ねぎ",
                  volume: "1/2個",
                },
                {
                  img: imgPath + "cohoSalmon_ingredient07.jpg?$staticlink$",
                  name: "バター",
                  volume: "10g",
                },
                {
                  img: imgPath + "cohoSalmon_ingredient08.jpg?$staticlink$",
                  name: "しめじ",
                  volume: "60g",
                },
                {
                  img: imgPath + "cohoSalmon_ingredient09.jpg?$staticlink$",
                  name: "まいたけ",
                  volume: "60g",
                },
                {
                  img: imgPath + "cohoSalmon_ingredient10.jpg?$staticlink$",
                  name: "しいたけ",
                  volume: "40g",
                },
                {
                  img: imgPath + "cohoSalmon_ingredient11.jpg?$staticlink$",
                  name: "トマトの水煮",
                  volume: "50g",
                },
                {
                  img: imgPath + "cohoSalmon_ingredient12.jpg?$staticlink$",
                  name: "ごぼう",
                  volume: "10cm",
                },
                {
                  img: imgPath + "cohoSalmon_ingredient13.jpg?$staticlink$",
                  name: "アスパラガス",
                  volume: "4本",
                },
                {
                  img: imgPath + "cohoSalmon_ingredient14.jpg?$staticlink$",
                  name: "パプリカ（赤・黄）",
                  volume: "各1/2個",
                },
                {
                  img: imgPath + "cohoSalmon_ingredient15.jpg?$staticlink$",
                  name: "白ワイン",
                  volume: "50㏄",
                },
                {
                  img: imgPath + "cohoSalmon_ingredient16.jpg?$staticlink$",
                  name: "水",
                  volume: "350㏄",
                },
                {
                  img: imgPath + "cohoSalmon_ingredient17.jpg?$staticlink$",
                  name: "ターメリック（サフランパウダーでも可）",
                  volume: "1g",
                },
                {
                  img: imgPath + "cohoSalmon_ingredient18.jpg?$staticlink$",
                  name: "コンソメ",
                  volume: "小さじ2",
                },
                {
                  img: imgPath + "cohoSalmon_ingredient19.jpg?$staticlink$",
                  name: "オリーブオイル",
                  volume: "大さじ2と少々",
                },
                {
                  img: imgPath + "cohoSalmon_ingredient20.jpg?$staticlink$",
                  name: "塩コショウ",
                  volume: "適量",
                },
                {
                  img: imgPath + "cohoSalmon_ingredient21.jpg?$staticlink$",
                  name: "レモン",
                  volume: "スライス2枚",
                },
                {
                  img: imgPath + "cohoSalmon_ingredient22.jpg?$staticlink$",
                  name: "バジルの葉",
                  volume: "適量",
                },
              ],
              howTo: {
                text: "紅鮭を両面焼き、一度取り出す。キノコ類、ゴボウを炒めて、一度取り出す。お米透き通るまで弱火で炒め調味料を入れて煮る。ひと煮立ちしたら取り出しておいた材料を入れ加熱。10分ほど蒸らし、レモンとバジルをトッピングしたら完成！",
                time: "所要時間　30分",
                contentsList: [
                  {
                    img: imgPath + "cohoSalmon_process01.jpg?$staticlink$",
                    num: "1",
                    text: "下準備<br>ごぼうはささがきにして水にさらしておく。<br>椎茸は石づきをとり、半分にカットし、しめじと舞茸は根元を切り落とし、小房に分けておく。",
                  },
                  {
                    img: imgPath + "cohoSalmon_process02.jpg?$staticlink$",
                    num: "2",
                    text: "紅鮭にハーブソルト少々とブラックペッパーパウダーを振る。<br>パエリアパン（フライパン）にオリーブオイル大さじ1を入れて熱し、紅鮭に軽く焼き色が付くまで両面焼き、取り出しておく。（完全に火は通さなくてOK）",
                  },
                  {
                    img: imgPath + "cohoSalmon_process03and04.jpg?$staticlink$",
                    num: "3",
                    text: "パエリアパンの汚れをサッとキッチンペーパーでふき取り、オリーブオイルを大さじ1入れ、みじん切りにしたニンニクと玉ねぎを炒める。",
                  },
                  {
                    img: "",
                    num: "4",
                    text: "バターを加え、キノコ類とささがきにしておいたごぼうを炒めて塩コショウを振り、一度全部取り出す。",
                  },
                  {
                    img: imgPath + "cohoSalmon_process05.jpg?$staticlink$",
                    num: "5",
                    text: "パエリアパンにオリーブオイルを少々足してお米をいれ、透き通るまで弱火で炒める。",
                  },
                  {
                    img: imgPath + "cohoSalmon_process06.jpg?$staticlink$",
                    num: "6",
                    text: "ターメリックとトマトの水煮缶を加え、軽く炒めたら、水、酒とコンソメを加えて煮る。ひと煮立ちしたら、④をお米の上にザっと広げ、パプリカとアスパラガスを並べ、さらに紅鮭を並べて蓋をする。弱火～中火で15分程加熱する。",
                  },
                  {
                    img: imgPath + "cohoSalmon_process07.jpg?$staticlink$",
                    num: "7",
                    text: "ごはんが炊き上がったら、蓋をしたまま10分蒸らす。<br>おこげを作りたい場合は蓋を外して加熱する。",
                  },
                  {
                    img: imgPath + "cohoSalmon_process08.jpg?$staticlink$",
                    num: "8",
                    text: "食べる直前にレモンとバジルをトッピングして完成です",
                  },
                ],
              },
            },
          };
          var json = JSON.stringify(recipeDataList);
          json = JSON.parse(json);
          var dataSetName = $(this).data("target");
          var dataSet = json[dataSetName];
          _modal.find(".c-modal__recipe__category").text(dataSet.category);
          _modal.find(".c-modal__recipe__title").text(dataSet.title);
          if (dataSetName != "satsumaBeef") {
            _modal.find(".c-modal__recipe__imagesAndMovies li").remove();
            var imageList = dataSet.imagesAndMoviesList;
            var imgMovBox = _modal.find(".c-modal__recipe__imagesAndMovies");
            for (var i = 0; i < imageList.length; i++) {
              var liUnit = imageList[i];
              if (liUnit.includes("jpg")) {
                imgMovBox.append('<li><img src="' + liUnit + '"></li>');
              } else {
                imgMovBox.append(
                  '<li><div style="padding:56.25% 0 0 0;position:relative;"><iframe src="' +
                    liUnit +
                    '"  style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe></div><script src="https://player.vimeo.com/api/player.js$staticlink$"></script>' +
                    "</li>"
                );
              }
            }
            if (imageList.length % 2 != 0) {
              var lastchild = _modal
                .find(".c-modal__recipe__imagesAndMovies li")
                .last();
              lastchild.addClass("-is_last");
            }
            $(".c-modal__recipe__movie").children().hide();
            $(".c-modal__recipe__movie").hide();
            $(".c-modal__recipe__satsuma").hide();
            if (dataSetName == "spinyLobster") {
              $(".c-modal__recipe__movie").show();
              $(".c-modal__recipe__movie > .-spinyLobster").show();
            } else if (dataSetName == "oilSabadines") {
              $(".c-modal__recipe__movie").show();
              $(".c-modal__recipe__movie > .-oilSabadines").show();
            }
          } else {
            _modal.find(".c-modal__recipe__imagesAndMovies li").remove();
            $(".c-modal__recipe__satsuma").show().css("display", "flex");
            $(".c-modal__recipe__movie").hide();
            $(".c-modal__recipe__movie").children().hide();
          }
          if (dataSet.person.img.length > 0) {
            _modal
              .find(".c-modal__recipe__person__image img")
              .attr("src", dataSet.person.img);
          } else {
          }
          _modal
            .find(".c-modal__recipe__person__info__job")
            .text(dataSet.person.job);
          _modal
            .find(".c-modal__recipe__person__info__name")
            .text(dataSet.person.name);
          _modal
            .find(".c-modal__recipe__person__text")
            .html(dataSet.person.text.replace(/\n/g, "<br>"));
          _modal
            .find(".c-modal__recipe__story__text")
            .html(dataSet.story.replace(/\n/g, "<br>"));
          _modal
            .find(".c-modal__recipe__material__volume")
            .text(dataSet.volume);
          _modal.find(".c-modal__recipe__material__inner_ul li").remove();
          var materialList = dataSet.materialList;
          var materialBox = _modal.find(".c-modal__recipe__material__inner_ul");
          for (var _i = 0; _i < materialList.length; _i++) {
            var materialUnit = materialList[_i];
            materialBox.append(
              '<li><img src="' +
                materialUnit.img +
                '"><p>' +
                materialUnit.name +
                "<br>" +
                materialUnit.volume +
                "</p></li>"
            );
          }
          _modal.find(".c-modal__recipe__howTo__text").text(dataSet.howTo.text);
          _modal.find(".c-modal__recipe__howTo__time").text(dataSet.howTo.time);
          _modal.find(".c-modal__recipe__howTo__contents li").remove();
          var howToList = dataSet.howTo.contentsList;
          var howToBox = _modal.find(".c-modal__recipe__howTo__contents");
          for (var _i2 = 0; _i2 < howToList.length; _i2++) {
            var howToUnit = howToList[_i2];
            var tmpStr = "";
            tmpStr += "<li>";
            if (howToUnit.img.length > 0) {
              tmpStr +=
                '<div class="c-modal__recipe__howTo__contents__image"><img src=' +
                howToUnit.img +
                ' alt=""></div>';
            }
            tmpStr +=
              '<div class="c-modal__recipe__howTo__contents__explain"><p class="c-modal__recipe__howTo__contents__number">' +
              howToUnit.num +
              '</p><p class="c-modal__recipe__howTo__contents__text">' +
              howToUnit.text +
              "</p></div>";
            tmpStr += "</li>";
            howToBox.append(tmpStr);
          }
          _modal.fadeIn(1e3);
          _modal.addClass("is-show");
          var _modalContents = $(".c-modal__content" + ".-recipe");
          var modalScroll = setInterval(function () {
            var val = _modalContents.scrollTop();
            if (val > 0) {
              clearInterval(modalScroll);
              _modalContents.scrollTop(0);
            }
          }, 100);
          var _modalContentsRecipeMaterialLi = $(
            ".c-modal__recipe__material__inner li"
          ).first();
          var _modalContentsRecipeMaterialImgSize =
            _modalContentsRecipeMaterialLi.width();
          var _modalContentsRecipeMaterialImg = $(
            ".c-modal__recipe__material__inner img"
          );
          _modalContentsRecipeMaterialImg.css({
            height: _modalContentsRecipeMaterialImgSize,
          });
          _modalContentsRecipeMaterialImg.css({
            width: _modalContentsRecipeMaterialImgSize,
          });
          $("body").append('<div class="c-modal__overlay"></div>');
          $(".c-modal__overlay").fadeIn("slow");
          $("html").addClass("is-fixed");
          $(".c-modal__overlay, .js-modalClose")
            .unbind()
            .click(function () {
              $("html").removeClass("is-fixed");
              $(".c-modal__body,.c-modal__overlay").fadeOut(
                "slow",
                function () {
                  $(".c-modal__overlay").remove();
                  _modal.removeClass("is-show");
                }
              );
            });
        });
      },
      { "animated-scroll-to": 1 },
    ],
    8: [
      function (require, module, exports) {
        "use strict";
        $(function () {
          $('a[href^="#"]').click(function () {
            var speed = 500;
            var href = $(this).attr("href");
            var target = $(href == "#" || href == "" ? "html" : href);
            var position = target.offset().top;
            $("html, body").animate({ scrollTop: position }, speed, "swing");
            return false;
          });
        });
      },
      {},
    ],
  },
  {},
  [3]
);
